// @TODO: FLU-193 Handle this.
export const integrationsClient = async (getCurrentToken, integrationSlug) => {
    const token = await getCurrentToken();
    if (integrationSlug.startsWith('/')) {
        integrationSlug = integrationSlug.substring(1);
    }
    return {
        get: async (url) => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/${integrationSlug}${url}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        },
        post: async (url, data) => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/${integrationSlug}${url}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        },
        put: async (url, data) => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/${integrationSlug}${url}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        },
        delete: async (url) => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/${integrationSlug}${url}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        },
    };
};
